import { useState, useEffect } from 'react';
import { useReactor } from '@livefree/reactive';
import { Button, Image, Spinner } from '@heroui/react';
import { CustomPin } from '@/shared/components';
import { reactive } from '@/core/reactive/reactive';

export const ConfigureAuthenticatorApp = reactive.component(
  ({ services, monitors }) => {
    const [info, setInfo] = useState({ qrCodeImageUrl: '', setupCode: '' });
    const [pin, setPin] = useState('');

    useReactor(services.my.setupTwoFactor, {
      success: response => {
        setInfo(response.payload);
      },
    });

    useReactor(services.my.validateTwoFactor, {
      success: response => {
        if (response.payload.success) {
          services.my.twoFactor();
        } else {
          setInfo(response.payload);
        }
      },
    });

    useEffect(() => {
      if (pin) {
        services.my.validateTwoFactor(1, pin);
      }
    }, [pin, services]);

    return monitors.twoFactor.executing ? (
      <Spinner label="Loading..." />
    ) : (
      <div className="w-full flex flex-col gap-4">
        {!info.qrCodeImageUrl && !info.setupCode && (
          <Button
            color="primary"
            isLoading={monitors.setupTwoFactor.executing}
            isDisabled={monitors.setupTwoFactor.executing}
            onPress={() => services.my.setupTwoFactor(1)}
          >
            Enable two-factor authentication
          </Button>
        )}

        {info.qrCodeImageUrl && info.setupCode && (
          <>
            <p className="px-1">
              1. Scan QR code with your authenticator app (Authy, Google, etc.).
            </p>
            <Image
              src={info.qrCodeImageUrl}
              alt={info.setupCode}
              classNames={{
                wrapper: 'border-default-200 border-medium rounded-small self-center w-2/3',
              }}
            />
            <p className="px-1">2. Enter code from your authenticator app to verify.</p>
            <CustomPin length={6} onComplete={setPin} />
            <Button
              color="success"
              className="w-full"
              isLoading={monitors.validateTwoFactor.executing}
              isDisabled={pin.length < 6}
              onPress={() => services.my.validateTwoFactor(1, pin)}
            >
              Verify
            </Button>
          </>
        )}
      </div>
    );
  },
  {
    name: 'ConfigureAuthenticatorApp',
    monitors: services => [
      services.my.setupTwoFactor,
      services.my.validateTwoFactor,
      services.my.twoFactor,
    ],
  },
);
